export default {
  getLinkCipher: state => state.linkCipher,
  getActiveSharedView: state => state.activeSharedView,
  getAppType: state => state.appType,
  getLinkType: state => state.linkType,
  getLinkDetails: state => state.linkDetails,
  getFetchLinkDetailsStatus: state => state.fetchLinkDetailsStatus,
  getLinkPassword: state => state.linkPassword,
  getSetupLinkPasswordStatus: state => state.setupLinkPasswordStatus,
  getLinkRestoreInfo: state => state.linkRestoreInfo,
  getFetchLinkRestoreInfoStatus: state => state.fetchLinkRestoreInfoStatus,
  getLinkContentItems: state => state.linkContentItems,
  getFetchLinkContentItemsStatus: state => state.fetchLinkContentItemsStatus,
  getRootFolderName: state => state.rootFolderName,
  getAtiBrandName: state => state.atiBrandName,
  getCbBrandName: state => state.cbBrandName
};
